import { useEffect, useState } from "react";

export const useDataStudioWorkspaceInternalState = (tableId: string | null) => {
  const [recommendationsOpen, setRecommendationsOpen] = useState(true);

  useEffect(() => {
    setRecommendationsOpen(true);
  }, [tableId]);

  return {
    recommendationsOpen,
    closeRecommendations: () => setRecommendationsOpen(false),
  };
};
